import React from "react";
import { Reveal } from "@/components/Reveal";
import { LeadForm } from "@/components/LeadForm";
import { IMAGES } from "@/data/site";
import { Building2, Users, Handshake } from "lucide-react";
import useSeo from "@/lib/useSeo";

export default function Corporate() {
  useSeo({ title: "Corporate & B2B Travel", description: "VacanzaGo for business — corporate travel, offsites, conferences, MICE and B2B ground handling across India." });
  const blocks = [
    { icon: Building2, t: "Corporate Travel", items: ["Group travel & hotel blocks", "Airport & ground transfers", "End-to-end corporate movement", "Dedicated coordination desk"] },
    { icon: Users, t: "Corporate Events", items: ["Offsites & retreats", "Conferences & MICE", "Annual functions & award nights", "Full event production"] },
    { icon: Handshake, t: "B2B Travel", items: ["Travel-agency partnerships", "Ground handling & operations", "Group operations at scale", "Hotel & transport coordination"] },
  ];
  return (
    <div className="pt-28 pb-24 bg-[#FFF7EC] min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="eyebrow">For business</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight mt-3 text-[#2A1808]">Corporate & B2B</h1>
          <p className="mt-4 text-lg text-[#553204]">A serious operations partner for group travel, corporate events and trade. We take ownership of the logistics so your team doesn't have to.</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20">
          {blocks.map((b, i) => (
            <Reveal key={b.t} delay={i * 80}>
              <div className="h-full rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-8">
                <b.icon size={28} className="text-[#F49E1A]" />
                <h3 className="font-display text-2xl mt-5 text-[#2A1808]">{b.t}</h3>
                <ul className="mt-4 space-y-2 text-sm text-[#8A6B47]">
                  {b.items.map((it) => <li key={it} className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-[#F49E1A]" /> {it}</li>)}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <Reveal className="img-zoom rounded-md overflow-hidden aspect-[4/3]">
            <img src={IMAGES.heroMountain} alt="Corporate travel" className="h-full w-full object-cover" loading="lazy" />
          </Reveal>
          <Reveal delay={100}>
            <p className="eyebrow">Request a proposal</p>
            <h2 className="font-display text-4xl font-medium tracking-tight mt-3 text-[#2A1808]">Let's talk logistics</h2>
            <p className="mt-3 text-[#553204]">Tell us your requirement — group size, destinations, dates — and we'll respond with a tailored plan.</p>
            <div className="mt-7">
              <LeadForm source="custom-trip" buttonLabel="Request proposal" waPrefix="Hi Vacanza Go, I have a corporate / B2B requirement." />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
